import { COLORS, RADIUS, SHADOWS } from "../../theme";

export const Style = {
  wrap: (rtl) => ({
    position: "fixed",
    bottom: { xs: "16px", md: "24px" },
    [rtl ? "left" : "right"]: { xs: "16px", md: "24px" },
    zIndex: 1300,
    display: "flex",
    flexDirection: "column",
    alignItems: rtl ? "flex-start" : "flex-end",
    gap: "10px",
  }),
  trigger: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    background: "rgba(26,26,26,0.92)",
    backdropFilter: "blur(16px)",
    border: `1px solid rgba(255,255,255,0.12)`,
    borderRadius: RADIUS.pill,
    color: COLORS.white,
    padding: "10px 18px",
    cursor: "pointer",
    boxShadow: SHADOWS.pill,
    fontSize: "14px",
    fontWeight: 600,
    userSelect: "none",
  },
  panel: {
    background: "rgba(26,26,26,0.97)",
    backdropFilter: "blur(16px)",
    border: `1px solid rgba(255,255,255,0.12)`,
    borderRadius: RADIUS.card,
    boxShadow: SHADOWS.pill,
    padding: "16px",
    width: "260px",
    color: COLORS.white,
  },
  sectionLabel: {
    fontSize: "12px",
    fontWeight: 700,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "rgba(255,255,255,0.5)",
    margin: "4px 0 8px",
  },
  optionsRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginBottom: "14px",
  },
  option: (active) => ({
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 12px",
    borderRadius: RADIUS.pill,
    border: `1px solid ${active ? COLORS.gold : "rgba(255,255,255,0.12)"}`,
    background: active ? "rgba(212,175,55,0.16)" : "rgba(255,255,255,0.04)",
    color: active ? COLORS.gold : COLORS.white,
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 600,
  }),
  flagImg: {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    objectFit: "cover",
  },
};
